<template>
  <div class="general-info">
    <div class="general-info__container">
      <AppBreadCrumbs/>
      <div class="general-info__row general-info__align-items-start">
        <StaticMenu :menuItems="menuItems" />
        <div class="general-info__column">
          <div class="general-info__title">
            <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">Платные услуги</h1>
          </div>
          <div class="general-info__row">
            <div class="article-list">
              <div class="article-list__mini-file" >
                <AppItemFiles v-for="(item,index) in folderDocuments.files" :key="index" :file_item="item" :current-path="folderDocuments.currentPath" :name_folder="link"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import {actionTypesDocuments} from '@/store/modules/documents'
import {mapState} from 'vuex'
import AppItemFiles from '@/components/Documents/ItemFiles.vue'
import AppBreadCrumbs from '@/components/BreadCrumbs.vue'
import StaticMenu from "@/components/StaticMenu.vue";

export default {
    name: "AppDocumentsPaidServices",

    components: { AppBreadCrumbs, AppItemFiles, StaticMenu },
    metaInfo() {
      return {
        title: 'Платные услуги | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Документы Алтайского краевого клинического перинатального центра ДАР. Платные услуги. Подготовьтесь к родам вместе с Алтайским краевым клиническим перинатальным центром ДАР.'
          },
          {
            name: 'keywords',
            content: 'платные услуги, документы, перинатальный центр ДАР'
          }
        ]
      };
    },
    data() {
      return {
        name: 'Платные услуги',
        link: 'paid-services',
        path: '/app/documents',
        menuItems: [
          { text: "Документы учреждения", link: "/documents/institution", active: false },
          { text: "Образование", link: "/documents/education", active: false },
          { text: "Пациентам", link: "/documents/patients", active: false },
          { text: "Платные услуги", link: "/documents/paid-services", active: true },
          { text: "Противодействие коррупции", link: "/documents/anti-corruption", active: false },
          { text: "Специальная оценка условий труда", link: "/documents/special-assessment", active: false },

        ],
      }
    },
    computed: {
      ...mapState({
        folderDocuments: (state) => state.documents.folderDocuments,
        isLoading: (state) => state.documents.isLoading,
      }),
    },

    mounted() {
      this.$store.dispatch(actionTypesDocuments.getNextFolderDocuments, {name: this.name, currentPath: this.path })
          .then(() => {
          })
          .catch((er) => {
            console.log("Ошибка", er);
          });
    }
  };
</script>
